import styled from "styled-components";

export const RootLayout = styled.div`
	height: 100%;
`;
export const BlockPage = styled.div`
	position: fixed;
	top: 0;
	width: 100%;
	height: 100%;
	background-color: rgba(0, 0, 0, 0.5);
	z-index: 999;
	display: flex;
	justify-content: center;
	align-items: center;
`;
